import React from 'react'; 
import {getData } from '../../../core/HttpAction';  
import Table from '../../../core/Table'; 
import {PdfGenrate} from '../../../core/Pdf'; 

const Url='/library/book-most-issued-report';
 
const CustomButton=({props})=>{   
    return<button style={{float:'left'}} type="button" onClick={()=>props.download()}   className="md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light">Download</button>;
};
 
const columns=[
  
    {
        key:'title',
        displayName:'Book Name'
    },
    {
        key:'isbn_no',
        displayName:'ISBN No'
    },
    {
        key:'count',
        displayName:'Total Book Issued'
    }  
];
 
class Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:''
            }, 
            data:[],
            preloader:true
        }; 
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData=()=>{
        getData(Url,this.state.params).then((res)=>{ 
            this.setState({data:res.data,preloader:false}); 
        });
    }

    handleFetch=(params)=>{
        this.setState({params:{...params},preloader:true},()=>{
            this.fetchData();
        });
    }
 
    download=()=>{
        const pdfArray=[
            {
                index:'table-view',
                data:document.getElementById('pdfContentData'),
            }
        ]; 
        PdfGenrate({pdfArray,filename:'top-book-issued'}); 
    }
 
    render() {
        let {preloader,data}=this.state; 
        return ( 
            <div> 
                <Table
                    data={data}
                    handleFetch={this.handleFetch}
                    preloader={preloader}
                    permission="library-top-books-report"
                    title="Top Issued Books"
                    columns={columns}
                    primaryKey="book_id" 
                    download={this.download} 
                    CustomButton={CustomButton}
                /> 
 
                <div style={{display:'none'}}>
                                        
                                            
                    <table id={'pdfContentData'} >
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Book Name</th> 
                                <th>ISBN No</th> 
                                <th>Total Book Issued</th>
                            </tr>
                        </thead>
                        <tbody>
                            { 
                                data.data && data.data.map((val,k)=>{ 
                                    return( 
                                        <tr key={k}>
                                            <td>{parseInt(k)+1} </td>
                                            <td>{val.title}</td>
                                            <td>{val.isbn_no}</td>
                                            <td>{val.count}</td>
                                        </tr> 
                                    );
                                })
                            }
                        </tbody> 
                    </table>                          
                </div> 
            </div>
        );
    }
}
export default Reports;


// WEBPACK FOOTER //
// ./src/components/Reports/LibraryReport/topIssuedBookReport.js